// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const quickRigId = (z.number());
export const quickRig = z.object({
    id: quickRigId,
    name: z.string(),
    purpose: z.string().nullable(),
    status: z.string(),
    closed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    layout: z.unknown(),
});
export const quickRigInitializer = z.object({
    id: quickRigId.optional(),
    name: z.string(),
    purpose: z.string().optional().nullable(),
    status: z.string().optional(),
    closed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    layout: z.unknown().optional(),
});
export const quickRigMutator = z.object({
    id: quickRigId.optional(),
    name: z.string().optional(),
    purpose: z.string().optional().nullable(),
    status: z.string().optional(),
    closed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    layout: z.unknown().optional(),
});
//# sourceMappingURL=QuickRig.js.map